<template>
  <vx-card no-shadow :title="$t(`GROUPVIEW.newGroup`)">
    <span v-html="$t(`GROUPVIEW.remember`)"></span>

    <!-- Info -->
    <vs-input class="w-full mb-base" :label-placeholder="$t(`GROUPVIEW.name`)" v-model="groupName"></vs-input>
    <vs-input class="w-full mb-base" :label-placeholder="$t(`GROUPVIEW.description`)" v-model="description"></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveChanges">{{$t(`GROUPVIEW.save`)}}</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelChanges">{{$t(`GROUPVIEW.clean`)}}</vs-button>
    </div>
  </vx-card>
</template>

<script>
import * as Groups from "./Groups";

export default {
  props: {
    value: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      groupName: "",
      description: ""
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }
  },
  methods: {
    async saveChanges() {
      if (this.groupName === null || this.groupName === undefined) {
        this.$vs.notify({
          title: "Nuevo Grupo",
          text: `ingresa un nombre para el grupo`,
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      if (this.groupName.length < 2) {
        this.$vs.notify({
          title: "Nuevo Grupo",
          text: `ingresa un nombre valido`,
          color: "warning",
          icon: "error",
          time: 4000
        });
        return false;
      }

      this.$vs.loading({ type: "sound" });

      try {
        let data = {
          name: this.groupName,
          description: this.description
        };

        const result = await Groups.saveGroup(data);

        this.$emit("input", { name: this.groupName, key: result.id });

        this.$vs.notify({
          title: "Grupos",
          text: "Grupo creado con exito!",
          iconPack: "feather",
          icon: "icon-bell",
          color: "primary",
          time: 6000
        });

        this.cancelChanges();
      } catch (error) {
        console.error("error", error);
        this.$vs.notify({
          title: "Grupos",
          text: `Ocurrio un error, al crear el Grupo(${error.message})`,
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    cancelChanges() {
      this.groupName = "";
      this.description = "";
    }
  }
};
</script>
